module.exports = __webpack_public_path__ + "img/gunspring-logo.59a90c07.svg";